// __mocks__/styleMock.js
// Used for jest config to prevent jest crashing because we include scss files in javascript.

module.exports = {};
